<!--
 * @Description: 简单版详情
 * @Author: huzhibo
 * @Email: hzbfun@gmail.com
 * @Date: 2020/11/16 14:59
 -->
<template>
  <!--发货地&收货地一口价-->
  <el-table
    :data="rules"
    :stripe="false"
    class="simple-detail__wrapper"
    align="center"
    max-height="400"
  >
    <!--规则名称-->
    <el-table-column
      align="center"
      min-width="120px"
      prop="name"
      label="规则名称"
    />
    <!--发货地 & 收货地-->
    <template v-if="freightType === '2'">
      <!--发货地-->
      <el-table-column align="center" min-width="250px" label="发货地">
        <span slot-scope="{ row }">{{ row.conditions[0].content }}</span>
      </el-table-column>
      <!--收货地-->
      <el-table-column align="center" min-width="250px" label="收货地">
        <span slot-scope="{ row }">{{ row.conditions[1].content }}</span>
      </el-table-column>
    </template>
    <!--电子路书-->
    <el-table-column
      v-if="freightType === '3'"
      align="center"
      min-width="250px"
      label="电子路书"
    >
      <span slot-scope="{ row }">{{ row.conditions[0].content }}</span>
    </el-table-column>
    <!--预约车型-->
    <el-table-column align="center" min-width="160px" label="预约车型">
      <span slot-scope="{ row }">{{
        row.conditions[vehicleTypeDataIdx].content
      }}</span>
    </el-table-column>
    <!--实际车型-->
    <el-table-column align="center" min-width="160px" label="实际车型">
      <span slot-scope="{ row }">{{
        row.conditions[vehicleTypeDataIdx + 1].content
      }}</span>
    </el-table-column>
    <!--一口价-->
    <el-table-column align="center" min-width="120px" label="一口价（￥）">
      <span slot-scope="{ row }">{{ row.fee.value }}</span>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: "simpleRecord",

  props: {
    rules: {
      type: Array,
      required: true
    },
    freightType: [Number, String]
  },

  computed: {
    // 车辆类型的数据开始序号
    vehicleTypeDataIdx() {
      switch (this.freightType) {
        case "2":
          return 2;
        case "3":
          return 1;
        default:
          return 0;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.simple-detail__wrapper {
  /deep/ {
    th,
    tr {
      td {
        background: #fff !important;
      }
    }
  }
}
</style>
